import { WorkData } from '../types';

/**
 * Filters works using inverted exclusion logic.
 * Shows all works except those explicitly marked with exclude_from_report=true.
 * This allows streaming works with metadata and final works without metadata
 * to both display correctly.
 */
export function filterStreamingWorks(works: WorkData[]): WorkData[] {
  // Show all works EXCEPT those explicitly marked for exclusion
  // If exclude_from_report is undefined or false, the work is shown
  return works.filter((w) => !w.exclude_from_report);
}
